import ReactModal from "react-modal";
import React from "react";
import { MODAL_SELECTORS } from "../modalSelectors";
import { MakerToken, TakerToken, GlobalStore } from "../../../../store/global/GlobalStore";
import { TRANSACTION_STATUSES } from "../../../../types/history";
import { Address } from "@wagmi/core";
import styled from "@emotion/styled";

export interface TransactionDetailsProps {
  takerToken: TakerToken;
  makerToken: MakerToken;
  status: TRANSACTION_STATUSES;
  txHash: Address;

  date: Date;
}
export const TransactionDetails: React.FC = () => {
  const modalSelector = GlobalStore.useState(s => s.modalSelector);
  const handleClose = () => {
    GlobalStore.update(s => {
      s.modalSelector = undefined;
    });
  };

  return (
    <Container>
      <ReactModal
        isOpen={modalSelector === MODAL_SELECTORS.TRANSACTION_DETAIL}
        className={`react-modal h-100`}
        shouldCloseOnOverlayClick={false}
        overlayClassName={"bg-transparent ms-auto"}
        onRequestClose={handleClose}
      >
        <div className="modal-content ms-auto float-end h-100" style={{ padding: "15px" }}>
          <div className={`modal-body`} style={{ paddingTop: 0 }}>
            <h5 className="text-center">Trade</h5>
          </div>
        </div>
      </ReactModal>
    </Container>
  );
};

// Sub-components

const Container = styled.div`
  position: absolute;
  right: 0;
`;
